import { APIProvider } from "@vimana/ui-components/dist/Components/API";
import { NavbarSettingsMenuController } from "@vimana/ui-components/dist/Components/App/AppNavbar";
import { AIChatContext } from "@vimana/ui-components/dist/Components/Chat/AI/AIChatContext";
import { ErrorBoundary } from "@vimana/ui-components/dist/Components/Core/ErrorBoundary";
import { ElevateSettingsMenu } from "@vimana/ui-components/dist/Components/LandingScreen/ElevateSettingsMenu";
import { NotificationsIconContext } from "@vimana/ui-components/dist/Components/LandingScreen/NotificationsIcon/NotificationsIconContext";
import { ProfileContext } from "@vimana/ui-components/dist/Components/Profile/ProfileContext";
import { ProfilePermissionsContext } from "@vimana/ui-components/dist/Components/Profile/ProfilePermissionsContext";
import { Suspense, useContext } from "react";
import { useMatch } from "react-router-dom";

import { ApplicationPropertiesContext } from "../ApplicationContext/ApplicationPropertiesController";
import { AuthController } from "../ApplicationContext/AuthController";
import { EnvContext } from "../ApplicationContext/EnvContext";
import { PlantContext } from "../PlantWrapper";
import usePageView from "../Utils/usePageView";
import { ApplicationRoutes } from "./ProtectedRoutes/ApplicationRoutes";

export const ProtectedRoutes = () => {
  const plantName = useContext(PlantContext);
  usePageView();
  const isForgotPassword = useMatch({ path: "/forgot-password", end: true });
  const isLandingRoute = useMatch({ path: "/", end: true });
  const isResetPassword = useMatch({ path: "/reset-password", end: true });
  const noSideBar = Boolean(isLandingRoute || isResetPassword);

  if (isForgotPassword) {
    return null;
  }

  return (
    <AuthController>
      <ApplicationPropertiesContext.Provider value={{}}>
        <EnvContext>
          <APIProvider plantName={plantName}>
            <ProfileContext.Provider>
              <ProfilePermissionsContext.Provider>
                <NotificationsIconContext.Provider>
                  <AIChatContext.Provider>
                    <NavbarSettingsMenuController settingsMenu={ElevateSettingsMenu}>
                      <ErrorBoundary>
                        <Suspense fallback={null}>
                          <ApplicationRoutes noSideBar={noSideBar} />
                        </Suspense>
                      </ErrorBoundary>
                    </NavbarSettingsMenuController>
                  </AIChatContext.Provider>
                </NotificationsIconContext.Provider>
              </ProfilePermissionsContext.Provider>
            </ProfileContext.Provider>
          </APIProvider>
        </EnvContext>
      </ApplicationPropertiesContext.Provider>
    </AuthController>
  );
};
